module.exports = __webpack_public_path__ + "img/code7.a2228958.png";